import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    SET_SPECS: (specs) => ({ specs }),
    CHANGE_NAME: (name) => ({ name }),
    LOAD: (mission) => mission,
    SET_COLLISIONS: (collisions) => ({ collisions }),
    SET_ELEVATIONS: (elevations) => ({ elevations }),
    // Command
    RESET_COMMANDS: () => ({}),
    REMOVE_COMMAND: (index) => ({ index }),
    SHIFT_COMMAND: (index, offset) => ({ index, offset }),
    UPDATE_COMMAND: (index, name, value) => ({ index, name, value }),
    // Waypoint
    APPEND_WAYPOINT: (waypoint) => ({ waypoint }),
    INSERT_WAYPOINT: (index, waypoint) => ({ index, waypoint }),
    MOVE_WAYPOINT: (id, waypoint) => ({ id, waypoint }),
    EDIT_WAYPOINT: (index, name, value) => ({ index, name, value }),
    EDIT_ALL_WAYPOINTS: (name, value) => ({ name, value }),
    // Survey
    APPEND_SURVEY: (boundary, positions, altitude) => ({ boundary, positions, altitude }),
    EDIT_SURVEY: (index, values) => ({ index, values }),
    // Return
    APPEND_RETURN_TO_LAUNCH: () => ({}),
  },
  { prefix: 'MISSION' }
);
